<script setup lang="ts">
import TmPendingDataPointRequests from './TmPendingDataPointRequests.vue';
</script>

<template>
  <div class="pt-5 px-6 flex flex-col">
    <div class="relative flex-1">
      <TmPendingDataPointRequests isLocationDisplayed />
    </div>
  </div>
</template>
